import React from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Container, Row, Col } from "react-bootstrap";
import partnersBanner from "../../Images/academic/academic-partner-banner.webp";
import aerenLogo from "../../Images/academic/alpha.webp";
import pearsonLogo from "../../Images/academic/per-lg.webp";
import diu from "../../Images/MOU/diu-logo.webp";
import indiana from "../../Images/MOU/indiana-logo.webp";
import rushford from "../../Images/MOU/rushford-logo.webp";
import henry from "../../Images/MOU/henry-logo.webp";

const AcademicPartners = () => {
  return (
    <>
      <title>
        ISBM University's Global Academic Partnerships
      </title>
      <meta name="Discover ISBM University's academic partners collaborating to enhance education, research, and global learning opportunities." />

      <meta
        name="SearchEngines"
        content="Google, Bing, Overture, Yahoo, AOL, Infoseek, LookSmart, Excite, Hotbot, Lycos, CNET,
        DogPile, Ask Jeeves, Teoma, Snap, WebCrawler, AltaVista, GigaBlast, isoHunt, Kayak, MetaCrawler"
      />
      <meta name="Robots" content="INDEX, FOLLOW" />
      <meta name="Author" content="ISBM University, isbmuniversity.edu.in/" />
      <meta name="Robots" content="INDEX,ALL" />
      <meta name="YahooSeeker" content="INDEX, FOLLOW" />
      <meta name="msnbot" content="INDEX, FOLLOW" />
      <meta name="googlebot" content="Default, follow" />
      <meta name="owner" content="isbmuniversity.edu.in/" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="2 days" />
      <meta
        property="og:title"
        content="ISBM University | Academic Partners Program | Collaboration"
      />
      <meta
        property="og:description"
        content="Explore collaborative academic ventures at ISBM University. Discover our esteemed partnerships fostering educational excellence and global learning opportunities."
      />
      <meta property="og:url" content="https://isbmuniversity.edu.in/" />
      <meta
        property="og:image"
        content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.jpg"
      />
      <meta property="og:image:alt" content="ISBM University" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="ISBM University" />
      <meta
        name="twitter:title"
        content="ISBM University | Academic Partners Program | Collaboration"
      />
      <meta
        name="twitter:description"
        content="Explore collaborative academic ventures at ISBM University. Discover our esteemed partnerships fostering educational excellence and global learning opportunities."
      />
      <meta
        name="twitter:image:src"
        content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.jpg"
      />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@ISBMUniversity" />
      <meta name="twitter:creator" content="@ISBMUniversity" />
      <meta name="twitter:domain" content="https://isbmuniversity.edu.in/" />
      <meta property="twitter:account_id" content="758619542734053376" />
      <meta
        name="keywords"
        content="Academic Partnerships, Collaborative Alliances, ISBM University Alliances"
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${partnersBanner})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>Our Academic Partners</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                    Home
                  </a>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Academic Partners
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="ptb-50">
        <div className="container-xxl">
          <Row>
            <Col lg={12}>
              <div className="text-center mb-5">
                <h2 className="text-blue section-title modern-title">
                  Collaborating for Excellence
                </h2>
                <p className="lead">
                  ISBM University partners with leading organizations to enhance
                  our educational offerings and create meaningful impact in the
                  field of education.
                </p>
              </div>
            </Col>
          </Row>

          {/* Aeren Foundation Partner */}
          <Row className="align-items-center mb-5 partner-card shadow-lg rounded m-0 bg-white">
            <Col lg={4} className="p-0">
              <div className="partner-logo-container h-100">
                <img
                  src={aerenLogo}
                  alt="Aeren Foundation"
                  className="object-fit-cover"
                />
              </div>
            </Col>
            <Col lg={8} className="p-4 p-lg-5">
              <div className="partner-content">
                <h3 className="text-blue mb-3">Aeren Foundation</h3>
                <div className="partner-badge mb-3">
                  <span className="badge bg-blue text-white">NGO Partner</span>
                </div>
                <p>
                  Arean Foundation is a government registered NGO, determined to
                  funding, footing and sustaining actual grassroots initiatives
                  focused at providing learning and wellbeing to disadvantaged
                  children. In this process, the foundation has achieved
                  position as the first ever grant maker and changing the face
                  of thousands of lives.
                </p>
                <p>
                  Alpha Foundation aims at Welfare Reforms for underprivileged
                  children, Social welfare and Health Welfare. It is an Indian
                  NGO for Social Services, Indian Child Welfare Services, Child
                  Education and Self Employment.
                </p>
                <div className="partner-highlights mt-4">
                  <h5 className="mb-3">Key Focus Areas:</h5>
                  <Row>
                    <Col md={6}>
                      <ul className="list-unstyled">
                        <li className="mb-2">
                          <i className="ti ti-star text-blue me-2"></i>Child
                          Education
                        </li>
                        <li className="mb-2">
                          <i className="ti ti-star text-blue me-2"></i>Social
                          Welfare
                        </li>
                      </ul>
                    </Col>
                    <Col md={6}>
                      <ul className="list-unstyled">
                        <li className="mb-2">
                          <i className="ti ti-star text-blue me-2"></i>Health
                          Welfare
                        </li>
                        <li className="mb-2">
                          <i className="ti ti-star text-blue me-2"></i>Self
                          Employment
                        </li>
                      </ul>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>

          {/* <Row className="align-items-center mb-5 partner-card shadow-lg rounded m-0 bg-white flex-lg-row-reverse">
            <Col lg={4} className="p-0 order-lg-2">
              <div className="partner-logo-container h-100">
                <img
                  src={pearsonLogo}
                  alt="Pearson Education"
                  className="object-fit-cover"
                />
              </div>
            </Col>
            <Col lg={8} className="p-4 p-lg-5 order-lg-1">
              <div className="partner-content">
                <h3 className="text-blue mb-3">Pearson Education</h3>

                <p>
                  Educating 100 million people worldwide, Pearson Education is
                  the world's biggest education company. Pearson Education's
                  solutions cover a wide spectrum of subjects including
                  business, technology, sciences, law and the humanities. They
                  include books and resources that help students learn, teachers
                  teach, and professionals evolve throughout their careers. The
                  carefully designed learning tools help people around the world
                  to expand their knowledge, develop their skills and realize
                  their potential. The company is committed to provide quality
                  content, assessment tools and educational services in all
                  available media, spanning the learning curve from birth
                  through university and beyond.
                </p>
                <p>
                  Pearson Education India specializes in the publication of
                  academic and reference books in the fields of computer
                  science, engineering, business & management, professional &
                  trade, higher education and competitive examination
                  preparation books. Pearson Education India is also India's
                  foremost publisher in the school segment (K-12), with book
                  lists in English language teaching (ELT), the humanities,
                  sciences and mathematics, from primary to senior secondary
                  classes.
                </p>
                <p>
                  With elaborate editorial facilities in Delhi, Chennai and
                  Chandigarh, Pearson Education India covers the entire
                  subcontinent and has specific divisions with experienced
                  editorial teams catering to all levels and fields of
                  education. The teams create indigenous publishing programmes
                  to meet local market needs, and undertake customized
                  publishing for schools, universities and other institutions.
                  Pearson Education India also works closely with authors and
                  customers through strong editorial development processes and
                  innovations in sales and marketing.
                </p>
              </div>
            </Col>
          </Row> */}

          <Row className="align-items-center mb-5 partner-card shadow-lg rounded m-0 bg-white flex-lg-row-reverse">
            <Col lg={4} className="p-0 order-lg-2">
              <div className="partner-logo-container h-100">
                <img
                  src={diu}
                  alt="Dresden INTERNATIONAL University GmbH"
                  className="object-fit-cover"
                />
              </div>
            </Col>
            <Col lg={8} className="p-4 p-lg-5 order-lg-1">
              <div className="partner-content">
                <h3 className="text-blue mb-3">
                  Dresden INTERNATIONAL University GmbH
                </h3>

                <p>
                  ISBM University has signed a MoU with Dresden International
                  University, Dresden, Germany. The MoU will pave the way for
                  students to enroll and get a comprehensive knowledge and
                  skills in market oriented programmes such as MSC and MBA in
                  Logistics Management, International Commercial and Contract
                  Management, Industrial Management in Microelectronics,
                  Non-Destructive Testing, among others with work opportunities
                  post-study tenure.
                </p>
              </div>
            </Col>
          </Row>

          <Row className="align-items-center mb-5 partner-card shadow-lg rounded m-0 bg-white flex-lg-row-reverse">
            <Col lg={4} className="p-0 order-lg-2">
              <div className="partner-logo-container h-100">
                <img
                  src={rushford}
                  alt="Rushford business School"
                  className="object-fit-cover w-75 m-auto"
                />
              </div>
            </Col>
            <Col lg={8} className="p-4 p-lg-5 order-lg-1">
              <div className="partner-content">
                <h3 className="text-blue mb-3">Rushford business School</h3>
                <p>
                  ISBM University and Rushford Business School are pleased to
                  announce a new partnership to offer students a global business
                  education. This partnership will allow students to earn a dual
                  degree from both universities, one from ISBM University in
                  India and one from Rushford Business School in Switzerland.
                </p>
              </div>
            </Col>
          </Row>

          <Row className="align-items-center mb-5 partner-card shadow-lg rounded m-0 bg-white flex-lg-row-reverse">
            <Col lg={4} className="p-0 order-lg-2">
              <div className="partner-logo-container h-100">
                <img
                  src={henry}
                  alt="Henry Harvin"
                  className="object-fit-cover"
                />
              </div>
            </Col>
            <Col lg={8} className="p-4 p-lg-5 order-lg-1">
              <div className="partner-content">
                <h3 className="text-blue mb-3">Henry Harvin</h3>
                <p>
                  ISBM University has signed a Memorandum of Understanding (MoU)
                  with Henry Harvin®, a global Edtech Company based out of US
                  and India, to conduct Training and Placement programmes for
                  its Students in over 600+ courses available with the Edtech
                  company like Six Sigma Green Belt, Tableau, Analytics using
                  Python/R (Business, Marketing, HR, Finance), Blockchain
                  Professional Course, Data Science with Python Course, etc. The
                  objective of the MoU is to offer on-the-job training and
                  practical training to students of either diploma, graduation
                  or post graduation in any stream to enhance their
                  employability and counter the issues with respect to skilled
                  labour scarcity in the region.
                </p>
              </div>
            </Col>
          </Row>

          <Row className="align-items-center mb-5 partner-card shadow-lg rounded m-0 bg-white flex-lg-row-reverse">
            <Col lg={4} className="p-0 order-lg-2">
              <div className="partner-logo-container h-100">
                <img
                  src={indiana}
                  alt="Indiana Tech University"
                  className="object-fit-cover"
                />
              </div>
            </Col>
            <Col lg={8} className="p-4 p-lg-5 order-lg-1">
              <div className="partner-content">
                <h3 className="text-blue mb-3">Indiana Tech University</h3>
                <p>
                  Our partnership with Indiana Tech signifies a commitment to
                  providing our students with a broader perspective and access
                  to a wider range of academic opportunities. This collaboration
                  opens the door to exchange programmes, joint research
                  initiatives, and shared resources, allowing students from both
                  institutions to benefit from a richer educational experience.
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default AcademicPartners;
